import { render, staticRenderFns } from "./onlineCustomer.vue?vue&type=template&id=6d4449d5&scoped=true"
import script from "./onlineCustomer.vue?vue&type=script&lang=js"
export * from "./onlineCustomer.vue?vue&type=script&lang=js"
import style0 from "./onlineCustomer.vue?vue&type=style&index=0&id=6d4449d5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4449d5",
  null
  
)

export default component.exports